import React from "react";
import "./fasilitas.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Fasilitas from "../../Media/Surrounding Cibubur/Surrounding";

const lokasi = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div id="surrounding" className="surroundingarea">
      <div className="judulfasilitas">Surrounding Area</div>
      <div className="container-surrounding">
        <div className="container-card">
          <div className="kartu">
            <Slider {...settings}>
              {Fasilitas.map((image, index) => (
                <div key={index}>
                  <img className="kartugambar1" src={image} alt="athena" />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default lokasi;
